import { API, Competition } from "@brg/api";
import { FlexBox } from "@brg/ui";
import { DafesProjectType } from "_competition/pages/AllCompetitionsPage/types";
import { LayoutConst } from "core";
import { FC, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";

export const Container = styled.div<{isCompetitionPage?: boolean}>`
  width: 270px;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;

 ${({ isCompetitionPage }) => isCompetitionPage && css`
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      width: 204px;
    }
 `}
 
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 204px;
  }


  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 168px;
  }
  ${({ isCompetitionPage }) => isCompetitionPage && css`
   @media (max-width: ${LayoutConst.screen.md}px) {
    width: 100%;
  }
 `}
  @media (max-width: 768px) {
    width: 174px;
    height: 100%;
    min-height: 243px;
  }
  @media (max-width: ${LayoutConst.screen.s + "px"}) {
    height: ${LayoutConst.competitionCard.s.h + "px"};
    width: ${(LayoutConst.competitionCard.s.w - 4) / 2 + "px"};
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {

    ${() => {
      const width = 100;
      const padding = 20;
      const calculatedWidth = `calc(((${width}vw - ${padding}px) - 4px) / 2)`;
      const calculatedHeight = `calc((${width}vw - ${padding}px) * 0.680)`;
      return css`
        width: ${calculatedWidth};
        height: ${calculatedHeight};
        max-width: ${calculatedWidth};
        max-height: ${calculatedHeight};
        min-width: ${calculatedWidth};
        min-height: ${calculatedHeight};
        img {
          object-fit: cover;
        }
      `;
    }}
  }
`;

export const TopSection = styled.div<{background?: string, color?: string, isCompetitionPage?: boolean}>`
  background-color: ${({ background }) => background};
  color: ${({ color }) => color};
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 24px 24px 16px;
  ${({ isCompetitionPage }) => isCompetitionPage && css`
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      padding: 20px 20px 12px;
    }
 `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    padding: 20px 20px 12px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 8px 16px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    padding: 16px 16px 12px;
  }
`;
export const BottomSection = styled.div<{ background: string, isCompetitionPage?: boolean }>`
  background-color: ${({ background }) => background};
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 20px 24px 16px;
   ${({ isCompetitionPage }) => isCompetitionPage && css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        padding: 14px 20px 12px;
      }
  `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    padding: 14px 20px 12px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 8px 16px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    padding: 16px 18px 16px;
  }
  @media (max-width: ${LayoutConst.screen.xsm + "px"}) {
    padding: 10px 18px 10px;
  }
`;
export const BestText = styled.div<{isCompetitionPage?: boolean}>`
  font-size: 70px;
  font-weight: 500;
  line-height: 65px; /* 92.857% */
  text-transform: uppercase;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
   ${({ isCompetitionPage }) => isCompetitionPage && css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
       font-size: 59px;
        font-weight: 500;
        line-height: 54px;
      }
  `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
      font-size: 59px;
        font-weight: 500;
        line-height: 54px;
    }
  @media (max-width: ${LayoutConst.screen.m + "px"}){
    font-size: 45px;
    font-weight: 500;
    line-height: 45px;
  }
   @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
            font-size: 49px;
        font-weight: 500;
        line-height: 49px;
    }

  }
`;
export const Text = styled.div<{isCompetitionPage?: boolean}>`
  font-size: 70px;
  font-weight: 500;
  line-height: 65px; /* 92.857% */
  text-transform: uppercase;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
   ${({ isCompetitionPage }) => isCompetitionPage && css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 59px;
        font-weight: 500;
        line-height: 54px
      }
  `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 59px;
        font-weight: 500;
        line-height: 54px;
    }
 @media (max-width: ${LayoutConst.screen.m + "px"}){
    font-size: 45px;
    font-weight: 500;
    line-height: 45px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
            font-size: 49px;
        font-weight: 500;
        line-height: 49px;
    }

  }
      
`;
export const PlateContainer = styled(FlexBox)`
  width: 160px;
  height: 172px;
  flex-direction: column;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    width: 120px;
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    width: 100px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    width: 20vw;
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}) {
    width: 21vw;
  }
  @media (max-width: ${LayoutConst.screen.xsm + "px"}) {
    width: 28vw;
  }
`;
export const PlateTopSection = styled(FlexBox)<{background?: string, color?: string}>`
  height: 50%;
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  padding: 16px 16px 8px;
  justify-content: flex-end;
  flex: 1;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
   padding: 12px 12px 4px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
  }
`;
export const PlateBottomSection = styled.div<{ background: string }>`
  background-color: ${({ background }) => background};
  padding: 16px;
  flex: 2;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
  
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    padding: 12px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
  }
`;
export const PlateBestText = styled.div`
  font-size: 40px;
  font-weight: 500;
  line-height: 92.857%;
  text-transform: uppercase;
  text-align: right;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 38px;
    }
  @media (max-width: ${LayoutConst.screen.m + "px"}){
      font-size: 28px;
    }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
        font-size: calc(1vw + 1vh + 12px);
      }
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}){
        font-size: calc(1vw + 1vh + 10px);
      }
  }

  }
`;

export const PlateText = styled.div`
  font-size: 40px;
  font-weight: 500;
  line-height: 92.857%;
  text-transform: uppercase;
  text-align: right;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 38px;
    }
  @media (max-width: ${LayoutConst.screen.m + "px"}){
      font-size: 28px;
    }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
        font-size: calc(1vw + 1vh + 12px);
        line-height: 115%;
      }
   @media (max-width: ${LayoutConst.screen.sm + "px"}){
        font-size: calc(1vw + 1vh + 10px);
      }
  }
      
`;

export const GridPlateContainer = styled(FlexBox)`
  width: 80px;
  height: 86px;
  flex-direction: column;
  // @media (max-width: ${LayoutConst.screen.mac13}px) {
  //   min-width: 60px;
  //   width: min-content;
  //   height: 64px;
  // }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    width: 60px;
    // height: 64px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    width: 56px;
    // height: 60px;
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}) {
    // min-width: 62px;
    // width: min-content;
    // height: 64px;

    width: 42px;
    height: 45px;
  }
`;


export const GridTopSection = styled(FlexBox)<{ background?: string, color?: string}>`
  height: 30px;
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  padding: 6px 6px 4px;
  justify-content: flex-end;
  flex: 1;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
   padding: 4px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
   padding: 6px 6px 4px;
  }
   @media (max-width: ${LayoutConst.screen.sm + "px"}) {
     padding: 5px 4px 2px;
  }
`;

export const GridBottomSection = styled.div<{ background: string }>`
  background-color: ${({ background }) => background};
  padding: 6px;
  flex: 2;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
  
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    padding: 4px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    padding: 6px;
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}) {
     padding: 4px;
  }
`;

export const GridBestText = styled.div`
  font-size: 22px;
  font-weight: 500;
  line-height: 92.857%;
  text-transform: uppercase;
  text-align: right;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 16px;
    }
  @media (max-width: ${LayoutConst.screen.m + "px"}){
      font-size: 14px;
    }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
         font-size: 22px;
      }
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}) {
     font-size: 11px;
  }

  }
`;

export const GridText = styled.div`
  font-size: 22px;
  font-weight: 500;
  line-height: 92.857%;
  text-transform: uppercase;
  text-align: right;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  // @media (max-width: ${LayoutConst.screen.l_12}px) {
  //   font-size: 16px;
  // }
  @media (max-width: ${LayoutConst.screen.m + "px"}){
      font-size: 14px;
    }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
          font-size: 22px;
      }
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}) {
     font-size: 11px;
  }
      
`;

enum MonthColors {
  Winter = "#8C6FDD",
  Sprint = "#EC5FB1",
  Summer = "#49A13F",
  Autumn = "#EB5829",
}

function getMonthColor(monthNumber: number): string {
  
  switch (monthNumber) {
    case 11:
    case 0:
    case 1:
      return MonthColors.Winter;
    case 2:
    case 3:
    case 4:
      return MonthColors.Sprint;
    case 5:
    case 6:
    case 7:
      return MonthColors.Summer;
    case 8:
    case 9:
    case 10:
      return MonthColors.Autumn;
    default:
      return "#000000";
  }
}

const getTopBlockStyles = (type: DafesProjectType) => {
  return type === DafesProjectType.art ? {
    background: '#151514',
    color: '#fff'
  } : {
    background: ' #F6C744',
    color: '#151514'
  }
}

type RatingTypes = {
  competition?: Competition;
  isPlate?: boolean;
  isGridPlate?: boolean;
  onhoverPlate?: boolean;
  isCompetitionPage?: boolean
};

export const RatingImgGenerate = ({
  competition,
  isPlate,
  isGridPlate,
  onhoverPlate,
  isCompetitionPage
}: RatingTypes) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [monthName, setMonthName] = useState(0);
  const [yearName, setYearName] = useState(2024);

  
  useEffect(() => {
    if (competition) {
      setMonthName(
        //@ts-ignore
        new Intl.DateTimeFormat(language, { month: "long" }).format(
           //@ts-ignore
          new Date(2024, competition?.ratingSettings?.month)
        )
      );
      //@ts-ignore
      setYearName(competition?.ratingSettings?.year);
    }
  }, [competition, language]);

  const competitionType = useMemo(() => {
    return competition?.ratingSettings?.ratingProjectType as DafesProjectType
  } , [competition])

  const topText = useMemo(() => {
    return competitionType === DafesProjectType.art ? 'BEST ART' : 'BEST'
  } , [competition])

  if (isPlate) {
    return (
      <PlateContainer style={{
        opacity: onhoverPlate ? 0 : 1,
        visibility: onhoverPlate ? 'hidden' : 'visible',
        transition: 'opacity 0.3s ease, visibility 0.3s ease'
      }}>
        <PlateTopSection {...getTopBlockStyles(competitionType)}>
          <PlateBestText>{topText}</PlateBestText>
        </PlateTopSection>
        <PlateBottomSection
         //@ts-ignore
          background={getMonthColor(competition?.ratingSettings?.month)}
        >
      <PlateText>{monthName}</PlateText>
      <PlateText>{yearName}</PlateText>
       
        </PlateBottomSection>
      </PlateContainer>
    );
  }
  if (isGridPlate) {
    return (
      <GridPlateContainer style={{
        opacity: onhoverPlate ? 0 : 1,
        visibility: onhoverPlate ? 'hidden' : 'visible',
        transition: 'opacity 0.1s ease, visibility 0.3s ease'
      }}>
        <GridTopSection {...getTopBlockStyles(competitionType)}>
          <GridBestText>{topText}</GridBestText>
        </GridTopSection>
        <GridBottomSection
         //@ts-ignore
          background={getMonthColor(competition?.ratingSettings?.month)}
        >
          <GridText>{monthName}</GridText>
          <GridText>{yearName}</GridText>
        </GridBottomSection>
      </GridPlateContainer>
    );
  }

    return (
      <Container isCompetitionPage={isCompetitionPage}>
        <TopSection isCompetitionPage={isCompetitionPage} {...getTopBlockStyles(competitionType)}>
          <BestText isCompetitionPage={isCompetitionPage}>{topText}</BestText>
        </TopSection>
        <BottomSection
         //@ts-ignore
          background={getMonthColor(competition?.ratingSettings?.month)}
          isCompetitionPage={isCompetitionPage}
        >
          <Text isCompetitionPage={isCompetitionPage}>{monthName}</Text>
          <Text isCompetitionPage={isCompetitionPage}>{yearName}</Text>
        </BottomSection>
      </Container>
    );

};
import { API, Competition } from "@brg/api";
import { FlexBox } from "@brg/ui";
import { DafesProjectType } from "_competition/pages/AllCompetitionsPage/types";
import { LayoutConst } from "core";
import { FC, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";

export const Container = styled.div<{isCompetitionPage?: boolean}>`
  width: 270px;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;

 ${({ isCompetitionPage }) => isCompetitionPage && css`
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      width: 204px;
    }
 `}
 
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 204px;
  }


  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 168px;
  }
  ${({ isCompetitionPage }) => isCompetitionPage && css`
   @media (max-width: ${LayoutConst.screen.md}px) {
    width: 100%;
  }
 `}
  @media (max-width: 768px) {
    width: 174px;
    height: 100%;
    min-height: 243px;
  }
  @media (max-width: ${LayoutConst.screen.s + "px"}) {
    height: ${LayoutConst.competitionCard.s.h + "px"};
    width: ${(LayoutConst.competitionCard.s.w - 4) / 2 + "px"};
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {

    ${() => {
      const width = 100;
      const padding = 20;
      const calculatedWidth = `calc(((${width}vw - ${padding}px) - 4px) / 2)`;
      const calculatedHeight = `calc((${width}vw - ${padding}px) * 0.680)`;
      return css`
        width: ${calculatedWidth};
        height: ${calculatedHeight};
        max-width: ${calculatedWidth};
        max-height: ${calculatedHeight};
        min-width: ${calculatedWidth};
        min-height: ${calculatedHeight};
        img {
          object-fit: cover;
        }
      `;
    }}
  }
`;

export const TopSection = styled.div<{background?: string, color?: string, isCompetitionPage?: boolean}>`
  background-color: ${({ background }) => background};
  color: ${({ color }) => color};
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 24px 24px 16px;
  ${({ isCompetitionPage }) => isCompetitionPage && css`
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      padding: 20px 20px 12px;
    }
 `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    padding: 20px 20px 12px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 8px 16px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    padding: 16px 16px 12px;
  }
`;
export const BottomSection = styled.div<{ background: string, isCompetitionPage?: boolean }>`
  background-color: ${({ background }) => background};
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 20px 24px 16px;
   ${({ isCompetitionPage }) => isCompetitionPage && css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        padding: 14px 20px 12px;
      }
  `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    padding: 14px 20px 12px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 8px 16px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    padding: 16px 18px 16px;
  }
  @media (max-width: ${LayoutConst.screen.xsm + "px"}) {
    padding: 10px 18px 10px;
  }
`;
export const BestText = styled.div<{isCompetitionPage?: boolean}>`
  font-size: 70px;
  font-weight: 500;
  line-height: 65px; /* 92.857% */
  text-transform: uppercase;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
   ${({ isCompetitionPage }) => isCompetitionPage && css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
       font-size: 59px;
        font-weight: 500;
        line-height: 54px;
      }
  `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
      font-size: 59px;
        font-weight: 500;
        line-height: 54px;
    }
  @media (max-width: ${LayoutConst.screen.m + "px"}){
    font-size: 45px;
    font-weight: 500;
    line-height: 45px;
  }
   @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
            font-size: 49px;
        font-weight: 500;
        line-height: 49px;
    }

  }
`;
export const Text = styled.div<{isCompetitionPage?: boolean}>`
  font-size: 70px;
  font-weight: 500;
  line-height: 65px; /* 92.857% */
  text-transform: uppercase;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
   ${({ isCompetitionPage }) => isCompetitionPage && css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 59px;
        font-weight: 500;
        line-height: 54px
      }
  `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 59px;
        font-weight: 500;
        line-height: 54px;
    }
 @media (max-width: ${LayoutConst.screen.m + "px"}){
    font-size: 45px;
    font-weight: 500;
    line-height: 45px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
            font-size: 49px;
        font-weight: 500;
        line-height: 49px;
    }

  }
      
`;
export const PlateContainer = styled(FlexBox)`
  width: 160px;
  height: 172px;
  flex-direction: column;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    width: 120px;
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    width: 100px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    width: 20vw;
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}) {
    width: 21vw;
  }
  @media (max-width: ${LayoutConst.screen.xsm + "px"}) {
    width: 28vw;
  }
`;
export const PlateTopSection = styled(FlexBox)<{background?: string, color?: string}>`
  height: 50%;
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  padding: 16px 16px 8px;
  justify-content: flex-end;
  flex: 1;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
   padding: 12px 12px 4px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
  }
`;
export const PlateBottomSection = styled.div<{ background: string }>`
  background-color: ${({ background }) => background};
  padding: 16px;
  flex: 2;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
  
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    padding: 12px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
  }
`;
export const PlateBestText = styled.div`
  font-size: 40px;
  font-weight: 500;
  line-height: 92.857%;
  text-transform: uppercase;
  text-align: right;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 38px;
    }
  @media (max-width: ${LayoutConst.screen.m + "px"}){
      font-size: 28px;
    }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
        font-size: calc(1vw + 1vh + 12px);
      }
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}){
        font-size: calc(1vw + 1vh + 10px);
      }
  }

  }
`;

export const PlateText = styled.div`
  font-size: 40px;
  font-weight: 500;
  line-height: 92.857%;
  text-transform: uppercase;
  text-align: right;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 38px;
    }
  @media (max-width: ${LayoutConst.screen.m + "px"}){
      font-size: 28px;
    }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
        font-size: calc(1vw + 1vh + 12px);
        line-height: 115%;
      }
   @media (max-width: ${LayoutConst.screen.sm + "px"}){
        font-size: calc(1vw + 1vh + 10px);
      }
  }
      
`;

export const GridPlateContainer = styled(FlexBox)`
  width: 80px;
  height: 86px;
  flex-direction: column;
  // @media (max-width: ${LayoutConst.screen.mac13}px) {
  //   min-width: 60px;
  //   width: min-content;
  //   height: 64px;
  // }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    width: 60px;
    // height: 64px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    width: 56px;
    // height: 60px;
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}) {
    // min-width: 62px;
    // width: min-content;
    // height: 64px;

    width: 42px;
    height: 45px;
  }
`;


export const GridTopSection = styled(FlexBox)<{ background?: string, color?: string}>`
  height: 30px;
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  padding: 6px 6px 4px;
  justify-content: flex-end;
  flex: 1;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
   padding: 4px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
   padding: 6px 6px 4px;
  }
   @media (max-width: ${LayoutConst.screen.sm + "px"}) {
     padding: 5px 4px 2px;
  }
`;

export const GridBottomSection = styled.div<{ background: string }>`
  background-color: ${({ background }) => background};
  padding: 6px;
  flex: 2;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
  
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    padding: 4px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    padding: 6px;
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}) {
     padding: 4px;
  }
`;

export const GridBestText = styled.div`
  font-size: 22px;
  font-weight: 500;
  line-height: 92.857%;
  text-transform: uppercase;
  text-align: right;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 16px;
    }
  @media (max-width: ${LayoutConst.screen.m + "px"}){
      font-size: 14px;
    }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
         font-size: 22px;
      }
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}) {
     font-size: 11px;
  }

  }
`;

export const GridText = styled.div`
  font-size: 22px;
  font-weight: 500;
  line-height: 92.857%;
  text-transform: uppercase;
  text-align: right;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  // @media (max-width: ${LayoutConst.screen.l_12}px) {
  //   font-size: 16px;
  // }
  @media (max-width: ${LayoutConst.screen.m + "px"}){
      font-size: 14px;
    }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
          font-size: 22px;
      }
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}) {
     font-size: 11px;
  }
      
`;

enum MonthColors {
  Winter = "#8C6FDD",
  Sprint = "#EC5FB1",
  Summer = "#49A13F",
  Autumn = "#EB5829",
}

function getMonthColor(monthNumber: number): string {
  
  switch (monthNumber) {
    case 11:
    case 0:
    case 1:
      return MonthColors.Winter;
    case 2:
    case 3:
    case 4:
      return MonthColors.Sprint;
    case 5:
    case 6:
    case 7:
      return MonthColors.Summer;
    case 8:
    case 9:
    case 10:
      return MonthColors.Autumn;
    default:
      return "#000000";
  }
}

const getTopBlockStyles = (type: DafesProjectType) => {
  return type === DafesProjectType.art ? {
    background: '#151514',
    color: '#fff'
  } : {
    background: ' #F6C744',
    color: '#151514'
  }
}

type RatingTypes = {
  competition?: Competition;
  isPlate?: boolean;
  isGridPlate?: boolean;
  onhoverPlate?: boolean;
  isCompetitionPage?: boolean
};

export const RatingImgGenerate = ({
  competition,
  isPlate,
  isGridPlate,
  onhoverPlate,
  isCompetitionPage
}: RatingTypes) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [monthName, setMonthName] = useState(0);
  const [yearName, setYearName] = useState(2024);

  
  useEffect(() => {
    if (competition) {
      setMonthName(
        //@ts-ignore
        new Intl.DateTimeFormat(language, { month: "long" }).format(
           //@ts-ignore
          new Date(2024, competition?.ratingSettings?.month)
        )
      );
      //@ts-ignore
      setYearName(competition?.ratingSettings?.year);
    }
  }, [competition, language]);

  const competitionType = useMemo(() => {
    return competition?.ratingSettings?.ratingProjectType as DafesProjectType
  } , [competition])

  const topText = useMemo(() => {
    return competitionType === DafesProjectType.art ? 'BEST ART' : 'BEST'
  } , [competition])

  if (isPlate) {
    return (
      <PlateContainer style={{
        opacity: onhoverPlate ? 0 : 1,
        visibility: onhoverPlate ? 'hidden' : 'visible',
        transition: 'opacity 0.3s ease, visibility 0.3s ease'
      }}>
        <PlateTopSection {...getTopBlockStyles(competitionType)}>
          <PlateBestText>{topText}</PlateBestText>
        </PlateTopSection>
        <PlateBottomSection
         //@ts-ignore
          background={getMonthColor(competition?.ratingSettings?.month)}
        >
      <PlateText>{monthName}</PlateText>
      <PlateText>{yearName}</PlateText>
       
        </PlateBottomSection>
      </PlateContainer>
    );
  }
  if (isGridPlate) {
    return (
      <GridPlateContainer style={{
        opacity: onhoverPlate ? 0 : 1,
        visibility: onhoverPlate ? 'hidden' : 'visible',
        transition: 'opacity 0.1s ease, visibility 0.3s ease'
      }}>
        <GridTopSection {...getTopBlockStyles(competitionType)}>
          <GridBestText>{topText}</GridBestText>
        </GridTopSection>
        <GridBottomSection
         //@ts-ignore
          background={getMonthColor(competition?.ratingSettings?.month)}
        >
          <GridText>{monthName}</GridText>
          <GridText>{yearName}</GridText>
        </GridBottomSection>
      </GridPlateContainer>
    );
  }

    return (
      <Container isCompetitionPage={isCompetitionPage}>
        <TopSection isCompetitionPage={isCompetitionPage} {...getTopBlockStyles(competitionType)}>
          <BestText isCompetitionPage={isCompetitionPage}>{topText}</BestText>
        </TopSection>
        <BottomSection
         //@ts-ignore
          background={getMonthColor(competition?.ratingSettings?.month)}
          isCompetitionPage={isCompetitionPage}
        >
          <Text isCompetitionPage={isCompetitionPage}>{monthName}</Text>
          <Text isCompetitionPage={isCompetitionPage}>{yearName}</Text>
        </BottomSection>
      </Container>
    );

};
